import JoditEditor from "@nkr/components/editor";
import config from '../../ticketing/jodit-editor-config';
import { ControlLabel, FormGroup, HelpBlock, Panel } from "react-bootstrap";

interface IProps {
    value?: string,
    onChange?: (property: string, value: string) => void
}

const EmailSignature = ({value, onChange}:IProps) => {
    const handlehangeEditorChange = (e: string) => {
        onChange('emailSignature', e);
    }

    const editorConfig = {...config}

    return (
        <Panel>
            <Panel.Heading>Outgoing Email Settings</Panel.Heading>
            <Panel.Body>
                <FormGroup>
                    <ControlLabel>Email Signature</ControlLabel>
                    <HelpBlock>This email signature will be applied to emails sent by the system on behalf of the contact.</HelpBlock>
                    <JoditEditor 
                        value={value}
                        config={editorConfig}
                        setFocus={true}
                        onChange={handlehangeEditorChange}
                        onBlur={() => null} 
                    />
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default EmailSignature;